import { render } from "./edit-contract.vue?vue&type=template&id=2e968942&scoped=true"
import script from "./edit-contract.vue?vue&type=script&lang=js"
export * from "./edit-contract.vue?vue&type=script&lang=js"

import "./edit-contract.vue?vue&type=style&index=0&id=2e968942&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e968942"]])

export default __exports__